import { render, staticRenderFns } from "./DrawdownTemp.vue?vue&type=template&id=3aca6e68&scoped=true&"
import script from "./DrawdownTemp.vue?vue&type=script&lang=js&"
export * from "./DrawdownTemp.vue?vue&type=script&lang=js&"
import style0 from "./DrawdownTemp.vue?vue&type=style&index=0&id=3aca6e68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aca6e68",
  null
  
)

export default component.exports